import React, { useMemo, useEffect, useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import ConfirmBox  from "./ConfirmBox";
import AlertBox from './AlertBox';
import axios from "axios";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const FileUpload = (props) => {
  const [list, setList] = useState([]);
  const [myFiles, setMyFiles] = useState([]);

  const classes = props.classes || null;
  const id = props.id;
  let deleteUrl = props.deleteUrl ;
  let downloadUrl = props.downloadUrl;
  const listUrl = props.listUrl;
  const uploadUrl = props.uploadUrl;
  const acceptType = props.acceptType || "image/*, audio/*, .pdf";
  const isEdit = props.isEdit || null;

  deleteUrl = deleteUrl.endsWith("/") ? deleteUrl : deleteUrl + "/";
  downloadUrl = downloadUrl.endsWith("/") ? downloadUrl : downloadUrl + "/";


  async function fetchData() {
    try {
      //console.log('listUrl:'+ listUrl)
      const response = await axios.get(listUrl);
     // console.log('data:' + response.data)
      setList(response.data);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const onDrop = useCallback(
    (acceptedFiles) => {
      setMyFiles([...myFiles, ...acceptedFiles]);
    },
    [myFiles]
  );

  const onSubmit = async () => {
    if (!id) {
      AlertBox("Error", "ID is required to submit files", "error");
      return;
    }
    const formData = new FormData();
    if (myFiles.length > 1) {
      myFiles.map((file) => {
        formData.append(file.name, file);
      });
    } else {
      formData.append("file", myFiles[0]);
    }

    formData.append("id", id);

    try {
      const res = await axios.post(uploadUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          //Track Progress
        },
      });
      if (res) {
        AlertBox("Success", "File(s) Uploaded", "success");
        setMyFiles([]);
        fetchData();
      }
    } catch (err) {
      if (err.response.status && err.response.status === 500) {
        AlertBox("Error", "There was a problem with the server", "error");
      } else {
        AlertBox("Error", err.response, "error");
      }
    }
  };

  async function deleteFile(file) {
    try {
      await axios.get(deleteUrl.replace(/.$/, '~') + btoa(file));
      AlertBox("Success", "File Deleted", "success");
      fetchData();
    } catch (error) {
      AlertBox("Error", error.response, "error");
    }
  }

  const removeFile = (e, file) => {
    e.preventDefault();
    const newFiles = [...myFiles];
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
  };

  const downloadFile = (e, file) => {
    e.preventDefault();
    let fullUrl = downloadUrl.replace(/.$/, '~') + btoa(file);
    //console.log('Full download url:' + fullUrl)
    window.open(fullUrl, "_blank");
  };

  const files = myFiles.map((file) => (
    <div key={file} style={{ width: "80%", textAlign: "left" }}>
     <button
        className={classes ? classes.removeButton : ""}
        onClick={(e) => {
          removeFile(e, file);
        }}
      >
        X
      </button>{" "} 
      {file.path}
    </div>
  ));

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: acceptType,
    multiple: true,
  });

  const dropStyle = useMemo(
    () => ({
      ...baseStyle,
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <div className="container">
      <div
        {...getRootProps({ dropStyle })}
        style={{ background: "lightgray", height: "50px" }}
      >
        <input name="sampleFile" {...getInputProps()} />
        <p style={{ textAlign: "center" }}>
          <br />
          Drag 'n' drop the files here, or click to select files
        </p>
      </div>
      {files.length > 0 && (
        <div align="center">
          <aside>
            <h4>Selected Files</h4>
            <ul>{files}</ul>
          </aside>
        </div>
      )}
      {myFiles && myFiles.length > 0 && (
        <div align="center">
          <button
            className={classes ? classes.uploadButton : ""}
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          >
            Upload
          </button>
        </div>
      )}
      <hr />
      <div style={{ width: "80%", textAlign: "left" }}>
        <h4>Uploaded Files</h4>
        <ul>
          {list.map((file, i) => {
            return (
              <div key={file}>
                <p key={i}>
                  <button
                    className={classes ? classes.downloadButton : ""}
                    onClick={(e) => {
                      downloadFile(e, file);
                    }}
                  >
                    ↓
                  </button>{" "}
                  <a>
                    <button
                      className={classes ? classes.removeButton : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        ConfirmBox(
                          "Confirmation",
                          "Are you sure you want to delete this file?",
                          "Yes",
                          "No",
                          () => {
                            deleteFile(file);
                          },
                          () => {}
                        );
                      }}
                    >
                      X
                    </button>
                  </a>{" "}
                  <span key={i}>{file}</span>
                </p>
              </div>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default FileUpload;